import { DocumentVerificationService } from "../_services/documentVerification.service";

export const DocumentVerificationAction = {
  getVehicleDetailsByMasterId,
  getDrivingLicenseDetailsByMasterId,
  getPassportDetailsByMasterId,
  getAdhharBasicDetailsByMasterId,
  getVoterDetailsByMasterId,
  mergeDocument,
};
function getVehicleDetailsByMasterId(values) {
  return DocumentVerificationService.getVehicleDetailsByMasterId(values);
}
function getDrivingLicenseDetailsByMasterId(values) {
  return DocumentVerificationService.getDrivingLicenseDetailsByMasterId(values);
}
function getPassportDetailsByMasterId(values) {
  return DocumentVerificationService.getPassportDetailsByMasterId(values);
}
function getAdhharBasicDetailsByMasterId(values) {
  return DocumentVerificationService.getAdhharBasicDetailsByMasterId(values);
}
function getVoterDetailsByMasterId(values) {
  return DocumentVerificationService.getVoterDetailsByMasterId(values);
}
function mergeDocument(values) {
  return DocumentVerificationService.mergeDocument(values);
}
